<div class="dialog-container">
    <h1 mat-dialog-title>{{ 'EDIT.DIALOG.' + data.quote.subType.toUpperCase() + '.TITLE' | translate }}</h1>
    <div mat-dialog-content>
        <form [formGroup]="editForm">
            <mat-form-field>
                <mat-label>{{ 'COMMON.DIALOG.CUSTOMER_PURCHASE_NUMBER.LABEL' | translate }}</mat-label>
                <input
                    type="text"
                    matInput
                    placeholder="{{ 'COMMON.DIALOG.CUSTOMER_PURCHASE_NUMBER.PLACEHOLDER' | translate }}"
                    formControlName="customerPurchaseNumber"
                />
            </mat-form-field>
            <mat-form-field *ngIf="data.quote.subType === 'template'">
                <mat-label>{{ 'COMMON.DIALOG.DESCRIPTION.LABEL' | translate }}</mat-label>
                <input
                    type="text"
                    matInput
                    placeholder="{{ 'COMMON.DIALOG.DESCRIPTION.PLACEHOLDER' | translate }}"
                    formControlName="templateDescription"
                />
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'COMMON.DIALOG.PRIMARY_SCHEME.LABEL' | translate }}</mat-label>
                <input
                    type="text"
                    matInput
                    placeholder="{{ 'COMMON.DIALOG.PRIMARY_SCHEME.PLACEHOLDER' | translate }}"
                    formControlName="primarySchemes"
                />
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions fxLayoutAlign="end">
        <button mat-button mat-dialog-close>{{ 'COMMON.DIALOG.CANCEL' | translate }}</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="dialogResult" [disabled]="!editForm.valid">
            {{ 'EDIT.DIALOG.EDIT' | translate }}
        </button>
    </div>
</div>
